// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractModuleUi } from '../_abstract/ui'
import { ModuleHeaderUi } from '../_components/ui'
import { AbstractNavProps, BootstrapImage, BootstrapNav } from '../../dsl/front'

import { ContactModule, ContactTabItem, ContactTabType } from './Contact.contracts'
import { ContactFormTabUI } from './_partials/ContactForm'
import { ContactLocationTabUI } from './_partials/ContactLocation'
import { ContactDataTabUI } from './_partials/ContactData'
import { AnyObject } from '../_contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component<ContactModuleUi>({
  name: 'ContactModuleUi',
  components: {
    ModuleHeaderUi,
    BootstrapNav,
    BootstrapImage,
    ContactFormTabUI,
    ContactLocationTabUI,
    ContactDataTabUI
  },

  template: `
    <section class="contact-module">
      <!-- TMP -->
      <div class="container">
        <div class="row" v-if="module.content.header">
          <div class="col">
            <ModuleHeaderUi :header="module.content.header" />
          </div>
        </div>
        <!-- Tabs -->
        <div class="row" v-if="tabs && tabs.length > 0">
          <div class="col">
            <BootstrapNav :items="tabs" :active-item.sync="activeTabIndex" class="contact__nav"/>

            <div v-for="tab in tabs" :key="tab.id" v-show="activeTabIndex === tab.id" class="contact__tab">
              <div class="container">
                <div class="row">
                  <div class="col">
                    <template v-if="tab.id === TabType.ContactForm">
                      <ContactFormTabUI :onSubmit="onSubmit" :welcomeFormConfig="siteService.getWelcomeFormConfig()" />
                    </template>
                    <template v-if="tab.id === TabType.ContactData">
                      <ContactDataTabUI :items="module.content.tabs[tab.id].content"/>
                    </template>
                    <template v-if="tab.id === TabType.Location">
                      <ContactLocationTabUI :location="module.content.tabs[tab.id].locationUrl"/>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END | TMP -->
    </section>
  `
})
export class ContactModuleUi extends AbstractModuleUi<ContactModule> {
  //
  public TabType = ContactTabType

  /**
   * ContactModule tabs , filter canDisplay and return `ContactTabItem`
   */
  public get tabs (): ContactTabItem[] {
    return [...Object.values(this.module.content.tabs).filter((t) => t.canDisplay).map((tab) => {
      return {
        label: this.$t(`modules.contact.tabs.${tab.id}.title`),
        value: tab.id,
        id: tab.id
      } as ContactTabItem
    })]
  }

  /**
   * Initial selected tab
   */
  public activeTabIndex: AbstractNavProps['activeItem'] = 'contactForm'

  public onSubmit (formData: AnyObject): Promise<void> {
    // Notice! Implement in client side
    return Promise.resolve()
  }
}
